module.exports = __webpack_public_path__ + "img/chestnut-tree-house-3186453.png";